import { API_URL, getAuthHeaders } from './config';

export interface PricingRule {
    id: string;
    club_id: string;
    name: string;
    days: number[];
    time_start: string;
    time_end: string;
    price_per_slot_60: number;
    price_per_slot_90: number;
    price_per_slot_120: number;
    priority: number;
}

export const pricingService = {
    listRules: async (): Promise<PricingRule[]> => {
        const response = await fetch(`${API_URL}/manager/pricing-rules`, {
            headers: getAuthHeaders()
        });
        if (!response.ok) throw new Error('Failed to fetch pricing rules');
        return response.json();
    },

    createRule: async (data: Partial<PricingRule>): Promise<PricingRule> => {
        const response = await fetch(`${API_URL}/manager/pricing-rules`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify(data)
        });
        if (!response.ok) {
            const err = await response.json() as any;
            throw new Error(err.error || 'Failed to create pricing rule');
        }
        return response.json();
    },

    deleteRule: async (id: string): Promise<void> => {
        const response = await fetch(`${API_URL}/manager/pricing-rules/${id}`, {
            method: 'DELETE',
            headers: getAuthHeaders()
        });
        if (!response.ok) {
            const err = await response.json() as any;
            throw new Error(err.error || 'Failed to delete pricing rule');
        }
    },

    updateRule: async (id: string, data: Partial<PricingRule>): Promise<PricingRule> => {
        const response = await fetch(`${API_URL}/manager/pricing-rules/${id}`, {
            method: 'PUT',
            headers: getAuthHeaders(),
            body: JSON.stringify(data)
        });
        if (!response.ok) {
            const err = await response.json() as any;
            throw new Error(err.error || 'Failed to update pricing rule');
        }
        return response.json();
    },

    calculatePrice: async (data: { club_id: string, date: string, time: string, duration: number, players: number, guest_count?: number }): Promise<{
        price: number,
        basePrice: number,
        isMember: boolean,
        currency: string,
        usage?: {
            used_hours: number;
            total_hours: number | null;
            used_guest_passes: number;
            total_guest_passes: number | null;
        };
        impact?: {
            hours_consumed: number;
            guest_passes_consumed: number;
        };
    }> => {
        const response = await fetch(`${API_URL}/pricing/calculate`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error('Failed to calculate price');
        return response.json();
    }
};
